/* eslint-disable */
export default {
  participants: 'Partecipanti',
  host: '(Host)',
  removeParticipant: 'Rimuovi partecipante',
  removeTitle: 'Rimuovi partecipante',
  removeDescription: 'Rimuovere {name} da questa conferenza?',
  confirmButtonText: 'Rimuovi',
  cancelButtonText: 'Annulla',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
